import {
  PAGEBUILDER_GENERAL_UPDATE_CUSTOM_CODE_SETTINGS,
  PAGEBUILDER_AMP_STORY_WIDGETS
} from '../reducers/builder/configReducer/actions';
import { ICustomCodePayload } from '../utils/interfaces';

export const updateCustomCodeGeneralSettings = (payload: ICustomCodePayload) => ({
  type: PAGEBUILDER_GENERAL_UPDATE_CUSTOM_CODE_SETTINGS,
  payload
});

export function updateAmpWidgetSettings(payload: any) {
  return {
    type: PAGEBUILDER_AMP_STORY_WIDGETS,
    payload
  };
}
